// extracted by mini-css-extract-plugin
module.exports = {"helpFAQ":"style_helpFAQ__Alvlu"};